<template>
  <div class="record">
    <div class="title" style="overflow:hidden">
      <label>{{ title2 }}</label>
      <router-link to="/personal/complaintRecord" v-if="title2 == '等级测试记录'">
        <span>申诉记录</span>
      </router-link>
      <el-select
          v-model="selectTime.time"
          placeholder="请选择时间段"
          style="float:right;width:148px"
          v-if="!title2 == '发票'"
      >
        <el-option v-for="item in time" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="con">
      <ul class="thead">
        <li v-for="(item, index) in thead" :key="index">{{ item }}</li>
      </ul>
      <div v-if="totalCount">
        <div class="tbody" v-if="title2 == '等级测试记录'">
          <ul>
            <li v-for="(item, index) in tbody" :key="index" class="tbody_con">
              <div class="order">
                <span
                    style="display:block;float:left"
                >订单时间：{{ item.creationTime|dateformat('YYYY-MM-DD HH:mm:ss') }}</span>
                <span style="display:block;float:right">订单号：{{ item.order_sn }}</span>
              </div>
              <div class="order_detail">
                <div class="detail_con">
                  <img
                      :src="imgPath+item.institutional_view"
                      style="width:100px;height:100px; margin-right:10px; float:left;"
                  />
                  <ul style="width:76%;float:left">
                    <li>
                      <label>测试班名称：</label>
                      <span>{{ item.test_class_title }}</span>
                    </li>
                    <li>
                      <label>机构名称：</label>
                      <span>{{ item.mechanism_fullName }}</span>
                    </li>
                    <li>
                      <label>测试地址：</label>
                      <span>{{
                          item.provinceName == item.cityName ? item.provinceName : item.provinceName + item.cityName
                        }}{{ item.districtName }}{{ item.test_detail_addr }}</span>
                    </li>
                    <li>
                      <label>测试等级：</label>
                      <span>{{ item.gradeKey | grade }}</span>
                    </li>
                    <li>
                      <label>测试时间：</label>
                      <span>
                        {{ item.test_start_time|dateformat('YYYY-MM-DD HH:mm:ss') }}至
                        <br/>
                        {{ item.test_end_time|dateformat('YYYY-MM-DD HH:mm:ss') }}
                      </span>
                    </li>
                    <li>
                      <label>联系人：</label>
                      <span>
                        {{ item.apply.contact }}
                      </span>
                    </li>
                    <li>
                      <label>电话：</label>
                      <span>
                        {{ item.apply.contact_number }}
                      </span>
                    </li>
                  </ul>
                  <!--<h4 style="padding-top:27px;margin-bottom:5px;">测试班名称：{{ item.test_class_title }}</h4>-->
                  <!--<h4>{{ item.grade }}</h4>-->
                </div>
                <div class="money">
                  <h4 style="margin-bottom:5px;">总额:¥{{ item.order_price }}</h4>
                  <h4>{{ item.payment_status | paymentStatus }}</h4>
                </div>
                <div
                    class="operate"
                    style="text-align: center;padding-top: 19px;"
                    v-if="judge(item.isBatch,item.payment_status)"
                >
                  <el-button @click="goPay(item.order_sn)">去支付</el-button>
                  <div
                      style="color:#E6A23C;text-align:center;cursor: pointer;margin-top:5px;font-size:15px"
                      @click="InvoiceVisible = true"
                  >查看发票信息
                  </div>
                </div>
                <div class="operate" v-if="item.payment_status == '3'">
                  <div
                      style="color:#D62000;text-align:center;cursor: pointer;font-size:15px"
                      @click="Achievements(item.test_class_id)"
                      v-if="item.score_qualified_judgment != 0"
                  >查看成绩
                  </div>
                  <div
                      style="color:#28B28B;text-align:center;cursor: pointer;font-size:15px"
                      @click="checInvoice(item.order_sn)"
                  >查看发票
                  </div>
                  <div
                      style="color:#E6A23C;text-align:center;cursor: pointer;font-size:15px"
                      @click="complain(item.id)"
                      v-if="item.isAppeal==false"
                  >申诉
                  </div>
                  <!-- <router-link to="/" style="color:#D62000">退费</router-link> -->
                </div>
              </div>
              <div v-if="item.refund_status == 2" class="refund_flag">
                <el-tag type="danger">已退费</el-tag>
              </div>
            </li>
          </ul>
        </div>
        <ul class="tbody" v-else>
          <li v-for="(item, index) in tbody2" :key="index" class="tbody2_con">
            <div class="order">
              <span
                  style="display:block;float:left"
              >订单时间：{{ item.creationTime|dateformat('YYYY-MM-DD HH:mm:ss') }}</span>
              <span style="display:block;float:right">订单号:{{ item.order_sn }}</span>
            </div>
            <div class="order_detail">
              <div style="overflow:hidden;width:40%;float:left;" class="order_detail_con">
                <img
                    src="/image/evaluationStaff/invoice.png"
                    style="width:100px;height:100px; margin-right:10px; float:left;"
                />
                <ul style="width:72%;float:left;line-height:26px;font-size:15px">
                  <li>
                    <label>名称：</label>
                    <span>{{ item.iname }}</span>
                  </li>
                  <li>
                    <label>等级：</label>
                    <span>{{ item.grade }}</span>
                  </li>
                </ul>
                <!-- <h4 style="padding-top:7px;margin-bottom:5px;font-size:15px;">{{ item.iname }}</h4>
                <h4 style="font-size:15px;">{{ item.grade }}</h4>-->
              </div>
              <div class="money" style="padding:40px 0;font-size:15px;">
                <h4>{{ item.invoice_type }}</h4>
              </div>
              <div class="detail" style="font-size:15px;">{{ item.invoice_status | invoiceStatus }}</div>
              <div class="operate" style="text-align: center;padding-top: 26px;">
                <el-button @click="checInvoice(item.order_sn)">发票详情</el-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <no-data v-else/>
      <makeOutInvoice :dialogVisible="InvoiceVisible" @cancel="cancelData" @default="defaultData"/>
    </div>
    <div
        v-if="title2 == '等级测试记录'"
        class="pagination"
        style="margin:auto;text-align:center;margin-top:20px"
    >
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="paging.limit"
          :total="totalCount"
          v-if="totalCount>5"
      ></el-pagination>
    </div>
    <div v-else class="pagination" style="margin:auto;text-align:center;margin-top:20px">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange2"
          :page-size="paging2.limit"
          :total="totalCount"
          v-if="totalCount>5"
      ></el-pagination>
    </div>
    <el-dialog title="成绩明细" :visible.sync="dialogTableVisible" :width="screenWidth>768?'40%':'90%'">
      <el-table :data="gridData">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column property="subject" label="考核内容" align="center"></el-table-column>
        <el-table-column property="score" label="成绩" align="center"></el-table-column>
      </el-table>
      <div class="hege" style="color:#FFFFFF">
        <span
            :style="score_qualified_judgment==1?'background:#67C23A':score_qualified_judgment==2?'background:#F56C6C':'background:#909399'"
        >{{ score_qualified_judgment|status }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="申诉"
        :visible.sync="dialogFormVisible"
        class="complaintDialog"
        :width="dialogFormVisibleWidth"
    >
      <el-form :model="form">
        <el-form-item label="申诉内容" :label-width="formLabelWidth">
          <el-input
              type="textarea"
              v-model="form.desc"
              placeholder="最多输入100个字"
              maxlength="100"
              @input="descInput"
          ></el-input>
          <p style="margin-top:5px">{{ remnant }}/100</p>
          <span style="color:rgb(230, 162, 60);">提示：申诉在没反馈之前，不得发起第二次申诉。</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTable">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="二维码支付" :visible.sync="paydialog" :width="screenWidth>768?'40%':'90%'" center
               :close-on-click-modal="false">
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img">
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {GetUserInvoiceInfo} from "@/api/admin/common.js";
import {
  GetTestRecordsList,
  GetInvoiceRecordsList,
  GetAthleteTestScoreList,
  CreateAthleteAppeal
} from "@/api/admin/athletes.js";
import noData from "@/views/admin/components/noData.vue";
import makeOutInvoice from "@/views/admin/components/makeOutInvoice.vue";
import {GDCloudPay, GetPaymentStatus,} from "@/api/admin/common.js";
import store from "@/store";
import {mapGetters} from "vuex";

export default {
  // inject: ['reload'],
  props: ["title"],
  components: {
    noData,
    makeOutInvoice
  },
  computed: {
    ...mapGetters(["screenWidth"])
  },
  data() {
    return {
      formData: {},
      payview: false,
      paydialog: false,
      paytime: null,
      sn: null,
      title2: "",
      time: [
        {
          value: "0",
          label: "近三个月"
        }
      ],
      selectTime: {},
      thead: [],
      tbody_Show: true,
      opeate_Show: true,
      tbody: [],
      tbody2: [],
      paging: {
        limit: 4,
        page: 1
      },
      paging2: {
        limit: 4,
        page: 1
      },
      totalCount: 0,
      gridData: [],
      dialogTableVisible: false,
      dialogFormVisible: false,

      form: {
        desc: ""
      },
      formLabelWidth: "120px",
      complaintContent: {},
      usertype: {},
      score_qualified_judgment: "2",
      remnant: 100,
      dialogTableVisibleWidth: "30%",
      dialogFormVisibleWidth: "30%",
      InvoiceVisible: false,
      custname: "",
      radio: "1",
      formInvoice: {},
      imgPath: window.apiObj.apiUrl
    };
  },
  beforeDestroy() {
    clearTimeout(this.paytime);
  },
  created() {
    this.intervalPay();
    this.paytime = setInterval(() => {
      this.intervalPay();
    }, 10000);
    //判断  等级测试记录还是 发票记录
    this.title2 = this.title;
    if (this.title2 == "等级测试记录") {
      this.thead = ["详情", "状态", "操作"];
      this.getList();
    } else {
      this.thead = ["详情", "发票", "操作"];
      this.getList2();
    }

  },
  methods: {
    // reload(){
    //   this.isRouterAlive =false;
    //   this.$nextTick(function(){
    //     this.isRouterAlive =true;

    //   })


    // },
    intervalPay() {
      if (this.payview) {
        if (this.sn != null) {
          GetPaymentStatus({order_sn: this.sn}).then(data => {
            if (data.data.result.orderStatus == 3) {
              this.$message({
                message: "支付完成",
                type: "success"
              });
              this.paydialog = false;
              this.payview = false;
              this.sn = null;
              this.getList();
            }
          });

        }

      }
    },
    getList() {
      GetTestRecordsList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tbody = list.items;
          this.totalCount = list.totalCount;
          this.defaultData();

        }
      });
    },
    getList2() {
      let user = store.state.user;
      if (user.userInfo) {
        this.usertype.user_type = user.userInfo.usertype;
      }
      GetInvoiceRecordsList(Object.assign(this.paging2, this.usertype)).then(
          data => {
            var list = data.data.result;
            if (list) {
              this.tbody2 = list.items;
              this.totalCount = list.totalCount;
            }
            // this.district = data.data.result.items;
            // // this.ruleForm.district = this.district[0].id;
          }
      );
    },
    defaultData() {
      GetUserInvoiceInfo({}).then(data => {
        var list = data.data.result;
        if (list.invoiceInfo) {
          if (list.invoiceInfo.custtype == "01") {
            this.radio = "2";
            this.formInvoice = list.invoiceInfo;
          } else {
            this.radio = "1";
          }
        }
      });
    },
    // 批量报名控制去支付显隐
    judge(isBatch, payment_status) {
      if (isBatch == true) {
        return false;
      } else {
        if (payment_status == "1") {
          return true;
        }
      }
    },
    // 分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      GetTestRecordsList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tbody = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    handleCurrentChange2(cpage) {
      this.paging2.page = cpage;
      GetInvoiceRecordsList(Object.assign(this.paging2)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tbody2 = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    // 查看成绩
    Achievements(testClassId) {
      if (this.screenWidth < 769) {
        this.dialogTableVisibleWidth = "90%";
      }
      this.dialogTableVisible = true;
      const testclassId = {
        testClassId
      };
      GetAthleteTestScoreList(Object.assign(testclassId)).then(data => {
        var list = data.data.result;
        //XXL 2021年4月19日 14:32:01   修改值展示方式

        if (list) {
          for (var ii = 0; ii < list.items.length; ii++) {
            var TempGridData = list.items[ii].score;
            if (TempGridData.length != 0) {
              this.gridData = list.items[ii].score;
              this.score_qualified_judgment = list.items[ii].score_qualified_judgment;
              break;
            }
          }
        }

        //XXL 修改 2021年4月19日 14:27:31
        // if (list) {
        //   var tempFlage = 1;
        //   this.gridData = list.items[0].score;
        //   if(this.gridData.length==0){
        //      this.gridData = list.items[1].score;
        //      tempFlage = 2;
        //   }
        //   if(tempFlage==1){
        //       this.score_qualified_judgment =
        //         list.items[0].score_qualified_judgment;
        //   }else{
        //       this.score_qualified_judgment =
        //         list.items[1].score_qualified_judgment;
        //   }

        // }
      });
    },
    // 申诉
    descInput() {
      var txtVal = this.form.desc.length;
      this.remnant = 100 - txtVal;
      if (this.remnant < 0) {
        this.remnant = 0;
      }
    },
    complain(id) {
      if (this.screenWidth < 1025) {
        this.dialogFormVisibleWidth = "60%";
      }
      if (this.screenWidth < 768) {
        this.dialogFormVisibleWidth = "80%";
      }
      this.complaintContent.appeal_source_id = id;
      this.dialogFormVisible = true;
    },
    // 申诉提交
    submitTable() {
      this.complaintContent.appeal_status = 0;
      this.complaintContent.appeal_content = this.form.desc;
      if (this.complaintContent.appeal_content.length > 100) {
        this.$message({
          message: "申诉内容请控制在100字以内",
          type: "warning"
        });
      } else {
        this.dialogFormVisible = false;
        CreateAthleteAppeal(Object.assign(this.complaintContent)).then(data => {
          var list = data.data.result;
          if (list.isSuccess == true) {
            this.$message({
              message: "您的申诉已提交，请等待,点击申诉记录中即可查看结果",
              type: "success"
            });
            this.getList();
          }
        });
      }
    },
    // 查看发票
    checInvoice(orderSn) {
      this.$router.push({
        path: "invoice",
        query: {orderSn}
      });
    },
    cancelData() {
      this.InvoiceVisible = false;
    },
    submitForm() {
    },
    //去支付
    goPay(e) {
      // this.$message({
      //   message: "订单确认中",
      //   type: "success"
      // });
      // this.$router.push({
      //    path: "/test/signUp",
      //    query:{id:item.id,key:item.gradeKey,fee:item.order_price}
      // });
      GDCloudPay({order_sn: e}).then(data => {
        this.sn = e;
        if (data.data.result.isSuccess) {
          this.paydialog = true;
          this.payview = true;
          //this.formData.img = "http://218.58.55.130:8765"+data.data.result.payCode;
          this.formData.img = this.imgPath + data.data.result.payCode;

        }
        // this.payview=true;
        // this.paydialog = true;
      });
    }
  },
  filters: {
    status: i => {
      switch (i) {
        case "0":
          return "未判定";
        case "1":
          return "合格";
        case "2":
          return "不合格";
      }
    },
    invoiceStatus: i => {
      switch (i) {
        case "0":
          return "开票中";
        case "1":
          return "开票成功";
        case "2":
          return "开票中";
        case "3":
          return "开票中";
      }
    },
    paymentStatus: i => {
      switch (i) {
        case "1":
          return "待支付";
        case "3":
          return "支付成功";
        case "5":
          return "支付失败";
        case "7":
          return "已退款";
        case "9":
          return "已关闭";
      }
    },
    grade: i => {
      switch (i) {
        case "1":
          return "一级";
        case "2":
          return "二级";
        case "3":
          return "三级";
        case "4":
          return "四级";
        case "5":
          return "五级";
        case "6":
          return "六级";
        case "7":
          return "七级";
        case "8":
          return "八级";
        case "9":
          return "九级";
        case "10":
          return "少儿一级";
        case "11":
          return "少儿二级";
        case "12":
          return "少儿三级";
        case "13":
          return "少儿四级";
        case "14":
          return "少儿五级";
        case "15":
          return "少儿六级";
        case "16":
          return "少儿七级";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.common_content {
  form {
    .el-textarea__inner {
      min-height: 100px !important;
    }
  }
}

.record {
  .title {
    label {
      font-size: 18px;
      line-height: 47px;
    }

    span {
      float: right;
      padding-top: 15px;
      font-size: 14px;
    }
  }

  .con {
    border: 1px solid #dcdfe6;
    padding: 5px;
    margin-top: 5px;

    .thead {
      background: #f5f6f6;
      overflow: hidden;

      li {
        float: left;
        padding: 6px;
        box-sizing: border-box;
        text-align: center;
      }

      li:first-child {
        width: 50%;
      }

      li:nth-child(2) {
        width: 20%;
      }

      li:nth-child(3) {
        width: 30%;
      }
    }

    .tbody {
      .tbody_con {
        position: relative;
        border-bottom: 1px solid #dcdfe6;

        .refund_flag {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 20px;
        }

        .order {
          padding: 6px 18px;
          background: #f5f6f6;
          overflow: hidden;
          margin-top: 10px;
        }

        .order_detail {
          padding: 15px 10px 0px 10px;
          overflow: hidden;

          .detail_con {
            overflow: hidden;
            width: 50%;
            float: left;

            ul {
              li {
                line-height: 25px;
                font-size: 15px;
                overflow: hidden;

                label {
                  display: block;
                  width: 90px;
                  float: left;
                }

                span {
                  display: block;
                  float: left;
                  width: 72%;
                }
              }
            }
          }

          .money {
            width: 20%;
            margin: auto;
            float: left;
            text-align: center;
            padding: 27px 0;
            border-left: 1px solid rgb(196, 196, 196);
            border-right: 1px solid rgb(196, 196, 196);

            h4 {
              font-weight: normal;
            }
          }

          .detail {
            width: 15%;
            margin: auto;
            float: left;
            text-align: center;
            padding: 39px 0;
            border-right: 1px solid rgb(196, 196, 196);

            a {
              color: #000000;
            }
          }

          .operate {
            padding-top: 25px;
            line-height: 24px;

            a {
              color: #000000;
              display: block;
              text-align: center;
              margin-bottom: 2px;
            }
          }
        }
      }

      .tbody2_con {
        border-bottom: 1px solid #dcdfe6;

        .order {
          padding: 6px 18px;
          background: #f5f6f6;
          overflow: hidden;
          margin-top: 10px;
        }

        .order_detail {
          padding: 15px 10px;
          overflow: hidden;

          h4 {
            font-weight: normal;
          }

          .money {
            width: 20%;
            margin: auto;
            float: left;
            text-align: center;
            padding: 27px 0;
            border-left: 1px solid rgb(196, 196, 196);
            border-right: 1px solid rgb(196, 196, 196);

            h4 {
              font-weight: normal;
            }
          }

          .detail {
            width: 15%;
            margin: auto;
            float: left;
            text-align: center;
            padding: 39px 0;
            border-right: 1px solid rgb(196, 196, 196);

            a {
              color: #000000;
            }
          }

          .operate {
            padding-top: 25px;
            line-height: 24px;

            a {
              color: #000000;
              display: block;
              text-align: center;
              margin-bottom: 2px;
            }
          }
        }
      }

      li:last-child {
        border-bottom: none;
      }
    }
  }

  .hege {
    text-align: center;

    span {
      display: inline-block;
      position: absolute;
      width: 60px;
      height: 60px;
      margin-top: 10px;
      border-radius: 50%;
      line-height: 60px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .tbody_con {
    .order {
      font-size: 14px;
    }

    .order_detail {
      .detail_con {
        img {
          display: none;
        }

        ul {
          width: 100% !important;

          li {
            label {
              width: 38% !important;
            }

            span {
              width: 62% !important;
            }
          }
        }
      }

      .money {
        font-size: 15px;
      }

      .operate {
        font-size: 15px;
      }
    }
  }

  .tbody2_con {
    .order {
      font-size: 14px;
    }

    .order_detail {
      img {
        display: none;
      }

      .money {
        font-size: 15px;
      }

      .operate {
        font-size: 15px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .record {
    .con {
      .tbody {
        .tbody_con {
          .order {
            span {
              float: none !important;
              line-height: 22px;
            }
          }

          .order_detail {
            .detail_con {
              width: 100% !important;
              border-bottom: 1px solid #f5f6f6;
              padding-bottom: 15px;
            }

            .money {
              border-left: none;
              border-right: none;
              width: 100%;
              border-bottom: 1px solid #f5f6f6;
              padding: 10px 0;
            }
          }
        }

        .tbody2_con {
          .order {
            span {
              float: none !important;
              line-height: 22px;
            }
          }

          .order_detail {
            .order_detail_con {
              width: 100% !important;
              border-bottom: 1px solid #f5f6f6;
              padding-bottom: 15px;

              h4 {
                padding-top: 0 !important;
              }
            }

            .money {
              border-left: none;
              border-right: none;
              width: 100%;
              border-bottom: 1px solid #f5f6f6;
              padding: 10px 0 !important;
              text-align: left;
            }

            .detail {
              width: 100%;
              border-right: 0;
              padding: 10px 0;
              text-align: left;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.complaintDialog {
  .el-dialog__body {
    padding: 10px 20px 0 20px;

    .el-form {
      .el-form-item {
        .el-form-item__label {
          width: 71px !important;
          text-align: left;
        }

        .el-form-item__content {
          line-height: 24px !important;
          margin-left: 71px !important;

          .el-textarea__inner {
            height: 100px;
            font-family: "微软雅黑";
          }
        }
      }
    }
  }
}

.paystyle {
  display: flex;
  justify-content: center;
}
</style>
